import { RootState } from 'data/reducer'
import { fetchCurrentPosition, setCurrentPosition, setError } from 'data/reducer/user'
import { AnyAction } from 'redux'
import { Epic, StateObservable } from 'redux-observable'
import { Observable, of } from 'rxjs'
import { catchError, filter, switchMap, withLatestFrom } from 'rxjs/operators'
import { requestGeolocation } from 'utils/geolocation'

export const fetchCurrentPositionEpic: Epic<AnyAction, AnyAction, RootState> = (
  action$: Observable<AnyAction>,
  state$: StateObservable<RootState>
) =>
  action$.pipe(
    filter(fetchCurrentPosition.match),
    withLatestFrom(state$),
    switchMap(([, state]) => {
      if (state.user.browserPosition.coordinates !== null) {
        return of(setCurrentPosition(state.user.browserPosition))
      }
      return requestGeolocation().then((position) => {
        const { latitude: lat, longitude: lng, accuracy } = position.coords
        const userPosition = {
          accuracy: accuracy,
          coordinates: {
            lat: lat,
            lng: lng,
          },
        }
        return setCurrentPosition(userPosition)
      })
    }),
    catchError(({ message }: GeolocationPositionError) => {
      return of(setError(message))
    })
  )
